/** A timestamp to the second, in the viewer's locale. The reuse and attach audit trail is read by time, so seconds matter. */
export function formatBenchWhen(iso: string | null | undefined): string {
  if (!iso) return '-';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '-';
  return d.toLocaleString(undefined, { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', second: '2-digit' });
}
